import React, { Component } from "react";
import Chart from "react-apexcharts";
import MonthlyAlarmTrendChart from "./MonthlyAlarmTrendChart";
import NodesByNetworkDomainChart from "./NodesByNetworkDomainChart";
import CorrelationChart from "./CorrelationChart";
import CRQTicketCountChart from "./CRQTicketCountChart";
import ImpactedDevicesChart from "./ImpactedDevicesChart";
import ImpactedHostsChart from "./ImpactedHostsChart";
import NetworkDomainAlarmChart from "./NetworkDomainAlarmChart";
import { properties } from "../../../constants/Propertise";
import { Picky } from "react-picky";

export default class TelcoCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      domainOptions: [
        { id: 1, name: "SEM" },
        { id: 2, name: "EAN" },
        { id: 3, name: "FTTP" },
        { id: 4, name: "HFC Network" },
        { id: 5, name: "DWDM" },
      ],
      severityOptions: [
        { id: 1, name: "Critical" },
        { id: 2, name: "Information" },
        { id: 3, name: "Major" },
        { id: 4, name: "Minor" },
        { id: 5, name: "Waring" },
      ],
      series: [
        {
          name: "",
          data: [30, 40, 45, 50],
        },
      ],
      options: {
        chart: {
          type: "bar",
          events: {
            click: function (chart, w, e) {
              // console.log(chart, w, e)
            },
          },
        },
        xaxis: {
          categories: ["April", "May", "June", "July"],
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return parseInt(val);
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        plotOptions: {
          bar: {
            columnWidth: "60%",
            distributed: true,
            borderRadius: 5,
          },
        },
      },
    };
  }
  render() {
    return (
      <>
        <div className="row" style={{ margin: "auto" }}>
          {/* -------------------network----------------------------- */}
          <div className="col-md-5" style={{ paddingRight: "0px" }}>
            <div className="px-4 py-1 rounded bg-primary text-white">
              Network
            </div>
            <div
              className="row py-2"
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "auto",
              }}
            >
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border">
                  <div
                    className="bg-info text-white"
                    style={{
                      height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.8rem",
                      fontWeight: 500,
                    }}
                  >
                    Domains
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={process.env.PUBLIC_URL + "/images/domains.png"}
                          height={30}
                        />
                      </span>
                      <p
                        className="card-title mb-0 mx-4"
                        style={{ fontSize: "1.4rem", fontWeight: 500 }}
                      >
                        8
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border">
                  <div
                    className="bg-info text-white"
                    style={{
                      height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.8rem",
                      fontWeight: 500,
                    }}
                  >
                    OEMs
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={process.env.PUBLIC_URL + "/images/oems.png"}
                          height={20}
                        />
                      </span>
                      <p
                        className="card-title mb-0 mx-4"
                        style={{ fontSize: "1.3rem", fontWeight: 500 }}
                      >
                        10
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border">
                  <div
                    className="bg-info text-white"
                    style={{
                      height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.8rem",
                      fontWeight: 500,
                    }}
                  >
                    Critical Alarms
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={
                            process.env.PUBLIC_URL + "/images/redwarning.jpg"
                          }
                          height={20}
                        />
                      </span>
                      <p
                        className="card-title mb-0"
                        style={{
                          fontSize: "1.3rem",
                          fontWeight: 500,
                          marginLeft: "35px",
                        }}
                      >
                        378.43k
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-7">
            {/* ------------------------------AI Engine------------------------------ */}
            <div className="px-4 py-1 rounded bg-primary text-white">
              AI Engine
            </div>
            <div
              className="row py-2"
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "auto",
              }}
            >
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border">
                  <div
                    className="bg-info text-white"
                    style={{
                      height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.8rem",
                      fontWeight: 500,
                    }}
                  >
                    AI Correlated Alarms
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/aicorrelatedalarms.png"
                          }
                          height={25}
                        />
                      </span>
                      <p
                        className="card-title mb-0 mx-4"
                        style={{ fontSize: "1.3rem", fontWeight: 500 }}
                      >
                        8252
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border">
                  <div
                    className="bg-info text-white"
                    style={{
                      height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.8rem",
                      fontWeight: 500,
                    }}
                  >
                    Predicted Alarms
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={process.env.PUBLIC_URL + "/images/success.jpg"}
                          height={20}
                        />
                      </span>
                      <p
                        className="card-title mb-0"
                        style={{
                          fontSize: "1.3rem",
                          fontWeight: 500,
                          marginLeft: "35px",
                        }}
                      >
                        700
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border">
                  <div
                    className="bg-info text-white"
                    style={{
                      height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.8rem",
                      fontWeight: 500,
                    }}
                  >
                    Prediction Coverage
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/predictioncoverage.png"
                          }
                          height={20}
                        />
                      </span>
                      <p
                        className="card-title mb-0 mx-4"
                        style={{ fontSize: "1.3rem", fontWeight: 500 }}
                      >
                        68.06%
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ flex: "1", margin: "0 0.2%" }}>
                <div className="card border">
                  <div
                    className="bg-info text-white"
                    style={{
                      height: "1.8rem",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                      fontSize: "0.8rem",
                      fontWeight: 500,
                    }}
                  >
                    Prediction Accuracy
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <span>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/predictionaccuracy.png"
                          }
                          height={25}
                        />
                      </span>
                      <p
                        className="card-title mb-0 mx-4"
                        style={{ fontSize: "1.3rem", fontWeight: 500 }}
                      >
                        71.81%
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="px-4 py-1 rounded bg-primary text-white mx-3">
            Network Automation
          </div>

          {/* ------------------------------------------ Network Automation------------------------------------------ */}
          <div className="row py-2" style={{ margin: "auto", padding: "1rem" }}>
            <div style={{ flex: "1", margin: "0 0.2%" }}>
              <div className="card border">
                <div
                  className="bg-info text-white"
                  style={{
                    height: "1.8rem",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                    fontSize: "0.8rem",
                    fontWeight: 500,
                  }}
                >
                  Open Incidents
                </div>
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <span>
                      <img
                        src={process.env.PUBLIC_URL + "/images/ticket.jpg"}
                        height={30}
                      />
                    </span>
                    <p
                      className="card-title mb-0"
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: 500,
                        marginLeft: "35px",
                      }}
                    >
                      756
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ flex: "1", margin: "0 0.2%" }}>
              <div className="card border">
                <div
                  className="bg-info text-white"
                  style={{
                    height: "1.8rem",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                    fontSize: "0.8rem",
                    fontWeight: 500,
                  }}
                >
                  CRQ Tickets
                </div>
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <span>
                      <img
                        src={process.env.PUBLIC_URL + "/images/crqtickets.png"}
                        height={25}
                      />
                    </span>
                    <p
                      className="card-title mb-0 mx-4"
                      style={{ fontSize: "1.3rem", fontWeight: 500 }}
                    >
                      811
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ flex: "1", margin: "0 0.2%" }}>
              <div className="card border">
                <div
                  className="bg-info text-white"
                  style={{
                    height: "1.8rem",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                    fontSize: "0.8rem",
                    fontWeight: 500,
                  }}
                >
                  Pipelines
                </div>
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <span>
                      <img
                        src={process.env.PUBLIC_URL + "/images/pipelines.png"}
                        height={25}
                      />
                    </span>
                    <p
                      className="card-title mb-0 mx-4"
                      style={{ fontSize: "1.3rem", fontWeight: 500 }}
                    >
                      200
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ flex: "1", margin: "0 0.2%" }}>
              <div className="card border">
                <div
                  className="bg-info text-white"
                  style={{
                    height: "1.8rem",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                    fontSize: "0.8rem",
                    fontWeight: 500,
                  }}
                >
                  Total Execution
                </div>
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <span>
                      <img
                        src={process.env.PUBLIC_URL + "/images/approved.png"}
                        height={25}
                      />
                    </span>
                    <p
                      className="card-title mb-0"
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: 500,
                        marginLeft: "35px",
                      }}
                    >
                      63
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ flex: "1", margin: "0 0.2%" }}>
              <div className="card border">
                <div
                  className="bg-info text-white"
                  style={{
                    height: "1.8rem",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                    fontSize: "0.8rem",
                    fontWeight: 500,
                  }}
                >
                  Success
                </div>
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <span>
                      <img
                        src={process.env.PUBLIC_URL + "/images/success.jpg"}
                        height={20}
                      />
                    </span>
                    <p
                      className="card-title mb-0"
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: 500,
                        marginLeft: "35px",
                      }}
                    >
                      56
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ flex: "1", margin: "0 0.2%" }}>
              <div className="card border">
                <div
                  className="bg-info text-white"
                  style={{
                    height: "1.8rem",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                    fontSize: "0.8rem",
                    fontWeight: 500,
                  }}
                >
                  Failed
                </div>
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <span>
                      <img
                        src={process.env.PUBLIC_URL + "/images/failed.jpg"}
                        height={30}
                      />
                    </span>
                    <p
                      className="card-title mb-0"
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: 500,
                        marginLeft: "35px",
                      }}
                    >
                      0
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ flex: "1", margin: "0 0.2%" }}>
              <div className="card border">
                <div
                  className="bg-info text-white"
                  style={{
                    height: "1.8rem",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                    fontSize: "0.8rem",
                    fontWeight: 500,
                  }}
                >
                  Partial Success
                </div>
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <span>
                      <img
                        src={process.env.PUBLIC_URL + "/images/warning.jpg"}
                        height={20}
                      />
                    </span>
                    <p
                      className="card-title mb-0"
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: 500,
                        marginLeft: "35px",
                      }}
                    >
                      7
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div
            className="row mb-2 justify-content-around"
            style={{ margin: "auto" }}
          >
            <div className="card col col-md-8">
              <div
                className="d-flex m-1"
                style={{ fontSize: "small", fontWeight: 500, color: "black" }}
              >
                Top 5 Network Domain Alarms
              </div>
              <div>
                <NetworkDomainAlarmChart />
              </div>
            </div>
            <div className="col col-md-3 px-0">
              <div className="card mb-2 col col-md-12">
                <div
                  className="d-flex p-1"
                  style={{ fontSize: "small", fontWeight: 500, color: "black" }}
                >
                  Domain:
                </div>
                <div>
                  <Picky
                    // value={}
                    options={this.state.domainOptions}
                    // onChange={this.handleDomainSelect}
                    valueKey="id"
                    labelKey="name"
                    multiple={false}
                    dropdownHeight={130}
                    name="name"
                    id="id"
                    keepOpen={false}
                    includeSelectAll={true}
                    includeFilter={true}
                    numberDisplayed={1}
                    placeholder={"Select"}
                    renderList={({
                      items,
                      selected,
                      multiple,
                      selectValue,
                      getIsSelected,
                    }) =>
                      items.map((item) => (
                        <li key={item.id} onClick={() => selectValue(item)}>
                          {getIsSelected(item) ? (
                            <strong>{item.name}</strong>
                          ) : (
                            item.name
                          )}
                        </li>
                      ))
                    }
                  />
                </div>
              </div>

              <div className="card mb-2 col col-md-12">
                <div
                  className="d-flex p-1"
                  style={{ fontSize: "small", fontWeight: 500, color: "black" }}
                >
                  Severity:
                </div>
                <div>
                  <Picky
                    // value={}
                    options={this.state.severityOptions}
                    // onChange={this.handleSeveritySelect}
                    valueKey="id"
                    labelKey="name"
                    multiple={false}
                    dropdownHeight={130}
                    name="name"
                    id="id"
                    keepOpen={false}
                    includeSelectAll={true}
                    includeFilter={true}
                    numberDisplayed={1}
                    placeholder={"Select"}
                    renderList={({
                      items,
                      selected,
                      multiple,
                      selectValue,
                      getIsSelected,
                    }) =>
                      items.map((item) => (
                        <li key={item.id} onClick={() => selectValue(item)}>
                          {getIsSelected(item) ? (
                            <strong>{item.name}</strong>
                          ) : (
                            item.name
                          )}
                        </li>
                      ))
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="card mx-3 mb-2">
            <div
              className="d-flex p-1"
              style={{ fontSize: "small", fontWeight: 500, color: "black" }}
            >
              Top 5 Impacted Devices
            </div>
            <div>
              <ImpactedDevicesChart />
            </div>
          </div>

          <div className="card mx-3 mb-2">
            <div
              className="d-flex p-1"
              style={{ fontSize: "small", fontWeight: 500, color: "black" }}
            >
              Correlation View
            </div>
            <div>
              <CorrelationChart />
            </div>
          </div>

          <div className="card mx-3 mb-2">
            <div
              className="d-flex p-1"
              style={{ fontSize: "small", fontWeight: 500, color: "black" }}
            >
              Monthly Alarm Trend
            </div>
            <div>
              <MonthlyAlarmTrendChart />
            </div>
          </div>

          <div className="card mx-3 mb-2">
            <div
              className="d-flex p-1"
              style={{ fontSize: "small", fontWeight: 500, color: "black" }}
            >
              Nodes By Network Domain
            </div>
            <div>
              <NodesByNetworkDomainChart />
            </div>
          </div>

          <div className="card mx-3 mb-2">
            <div
              className="d-flex p-1"
              style={{ fontSize: "small", fontWeight: 500, color: "black" }}
            >
              Top 10 Impacted Hosts
            </div>
            <div>
              <ImpactedHostsChart />
            </div>
          </div>

          <div className="card mx-3 mb-2">
            <div
              className="d-flex p-1"
              style={{ fontSize: "small", fontWeight: 500, color: "black" }}
            >
              No of CRQ Tickets
            </div>
            <div>
              <CRQTicketCountChart />
            </div>
          </div>
        </div>
      </>
    );
  }
}
